import { DropdownToggle } from 'reactstrap';

export default DropdownToggle;
